//切换头像
export const SWITCH_LOGO="SWITCH_LOGO";

export const ADD_TODO = 'ADD_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const SHOW_ALL = 'SHOW_ALL';
export const SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER';
//菜单
export const MENU_ROUTES = 'MENU_ROUTES';

//登录刷新菜单
export const REFRESH_MENU="REFRESH_MENU";
//退出刷新菜单
export const LOGOUT="LOGOUT";

//附件
export const PUSH_ATTACH_ID = 'PUSH_ATTACH_ID';
export const REMOVE_ATTACH_ID = 'REMOVE_ATTACH_ID';
export const SET_ATTACH_WALL_IDENTITY = 'SET_ATTACH_WALL_IDENTITY';//设置附件墙唯一表示

//级联地址
export const CASCADE_ADDRESS_LEVEL1 = 'CASCADE_ADDRESS_LEVEL1';
export const CASCADE_ADDRESS_LEVEL2 = 'CASCADE_ADDRESS_LEVEL2';
export const CASCADE_ADDRESS_LEVEL3 = 'CASCADE_ADDRESS_LEVEL3';
export const CASCADE_ADDRESS_LEVEL4 = 'CASCADE_ADDRESS_LEVEL4';
export const CASCADE_ADDRESS_LEVEL5 = 'CASCADE_ADDRESS_LEVEL5';
//清除级联地址
export const CLEAR_CASCADE_ADDRESS_ACTION = 'CLEAR_CASCADE_ADDRESS_ACTION';
//纳税人登记
export const SET_ETAX_TAXPAYER_INFO = 'SET_ETAX_TAXPAYER_INFO';
//设置纳税人收货地址
export const SET_DELIVERY_ADDRESS_ACTION = 'SET_DELIVERY_ADDRESS_ACTION';
//分支列表中分支的key
export const BRANCH_KEY_ACTION = 'BRANCH_KEY_ACTION';
//添加分支
export const ADD_BRANCH_ACTION = 'ADD_BRANCH_ACTION';
//修改分支
export const MODIFY_BRANCH_ACTION = 'MODIFY_BRANCH_ACTION';
//删除分支
export const DELETE_BRANCH_ACTION = 'DELETE_BRANCH_ACTION';
//分支列表数据全替换
export const FULL_COVERAGE_BRANCH_ACTION = 'FULL_COVERAGE_BRANCH_ACTION';
//选中的设备信息
export const SELECT_DEVICE_INFO = 'SELECT_DEVICE_INFO';
//清除设备信息
export const CLEAR_DEVICE_INFO = 'CLEAR_DEVICE_INFO';
//添加设备
export const ADD_DEVICE_ACTION = 'ADD_DEVICE_ACTION';
//修改设备
export const MODIFY_DEVICE_ACTION = 'MODIFY_DEVICE_ACTION';
//删除设备
export const DELETE_DEVICE_ACTION = 'DELETE_DEVICE_ACTION';
//设备列表数据全替换
export const FULL_COVERAGE_DEVICE_ACTION = 'FULL_COVERAGE_DEVICE_ACTION';
//分支添加设备
export const ADD_BRANCH_DEVICE_ACTION = 'ADD_BRANCH_DEVICE_ACTION';
//分支修改设备
export const MODIFY_BRANCH_DEVICE_ACTION = 'MODIFY_BRANCH_DEVICE_ACTION';
//分支删除设备
export const DELETE_BRANCH_DEVICE_ACTION = 'DELETE_BRANCH_DEVICE_ACTION';
//分支清除设备信息
export const CLEAR_BRANCH_DEVICE_ACTION = 'CLEAR_BRANCH_DEVICE_ACTION';
//分支设备列表全替换
export const FULL_COVERAGE_BRANCH_DEVICE_ACTION = 'FULL_COVERAGE_BRANCH_DEVICE_ACTION';
//分支添加设备后的返回页面地址
export const BRANCH_ADD_DEVICE_BACK_URL_ACTION = 'BRANCH_ADD_DEVICE_BACK_URL_ACTION';
//分支修改设备后的返回页面地址
export const BRANCH_MODIFY_DEVICE_BACK_URL_ACTION = 'BRANCH_MODIFY_DEVICE_BACK_URL_ACTION';
//分支查看设备后的返回页面地址
export const BRANCH_VIEW_DEVICE_BACK_URL_ACTION = 'BRANCH_VIEW_DEVICE_BACK_URL_ACTION';
//税种列表
export const  TAX_TYPE_LIST_ACTION = 'TAX_TYPE_LIST_ACTION';
//登记申请为拒绝状态的数据
export const REJECTED_DATA_ACTION = 'REJECTED_DATA_ACTION';
//登记业务中组件的隐藏状态
export const  DEVICE_GRID_DISPLAY_ACTION = 'DEVICE_GRID_DISPLAY_ACTION';
export const  BRANCH_GRID_DISPLAY_ACTION = 'BRANCH_GRID_DISPLAY_ACTION';
export const  BRANCH_DEVICE_GRID_DISPLAY_ACTION = 'BRANCH_DEVICE_GRID_DISPLAY_ACTION';
export const  BRANCH_CONTACT_DETAILS_DISPLAY_ACTION = 'BRANCH_CONTACT_DETAILS_DISPLAY_ACTION';
export const  DELIVERY_METHOD_DISPLAY_ACTION = 'DELIVERY_METHOD_DISPLAY_ACTION';
export const  DEREGISTRATION_LINK_DISPLAY_ACTION = 'DEREGISTRATION_LINK_DISPLAY_ACTION';
//登记业务中组件的置灰状态
export const  EFD_EFFECTIVE_DATE_DISABLED_ACTION = 'EFD_EFFECTIVE_DATE_DISABLED_ACTION';
export const  INVOICING_EFFECTIVE_DATE_DISABLED_ACTION = 'INVOICING_EFFECTIVE_DATE_DISABLED_ACTION';
export const  APPLY_DEVICES_RADIO_DISABLED_ACTION = 'APPLY_DEVICES_RADIO_DISABLED_ACTION';
export const  BRANCH_APPLY_DEVICES_RADIO_DISABLED_ACTION = 'BRANCH_APPLY_DEVICES_RADIO_DISABLED_ACTION';
export const  DELIVERY_METHOD_RADIO_DISABLED_ACTION = 'DELIVERY_METHOD_RADIO_DISABLED_ACTION';
//选择主营业务
export const SELECT_MAIN_BUSINESS_ACTION = 'SELECT_MAIN_BUSINESS_ACTION';
//清除主营业务
export const CLEAR_MAIN_BUSINESS_ACTION = 'CLEAR_MAIN_BUSINESS_ACTION';
//选择副营业务
export const SELECT_SECONDARY_BUSINESS_ACTION = 'SELECT_SECONDARY_BUSINESS_ACTION';
//删除副营业务
export const DELETE_SECONDARY_BUSINESS_ACTION = 'DELETE_SECONDARY_BUSINESS_ACTION';
//批量操作副营业务
export const BATCH_OPERATE_SECONDARY_BUSINESS = 'BATCH_OPERATE_SECONDARY_BUSINESS';
//清除副营业务
export const CLEAR_SECONDARY_BUSINESS_ACTION = 'CLEAR_SECONDARY_BUSINESS_ACTION';
//停用表单添加分支
export const ADD_DEACTIVATION_BRANCH_ACTION = 'ADD_DEACTIVATION_BRANCH';
export const ADD_DEACTIVATION_DEVICE_ACTION = 'ADD_DEACTIVATION_DEVICE';
//停用表单修改分支
export const MODIFY_DEACTIVATION_BRANCH_ACTION='MODIFY_DEACTIVATION_BRANCH_ACTION';
export const MODIFY_DEACTIVATION_DEVICE_ACTION='MODIFY_DEACTIVATION_DEVICE_ACTION';
//停用表单删除分支
export const DELETE_DEACTIVATION_BRANCH_ACTION='DELETE_DEACTIVATION_BRANCH_ACTION';
export const DELETE_DEACTIVATION_DEVICE_ACTION='DELETE_DEACTIVATION_DEVICE_ACTION';
//纳税人分支设备状态
export const TAXPAYER_BRANCH_DEVICE_STATUS='TAXPAYER_BRANCH_DEVICE_STATUS';
//激活
export const ADD_REACTIVATION_BRANCH_ACTION = 'ADD_REACTIVATION_BRANCH';
export const ADD_REACTIVATION_DEVICE_ACTION = 'ADD_REACTIVATION_DEVICE';
export const MODIFY_REACTIVATION_BRANCH_ACTION='MODIFY_REACTIVATION_BRANCH_ACTION';
export const MODIFY_REACTIVATION_DEVICE_ACTION='MODIFY_REACTIVATION_DEVICE_ACTION';
export const DELETE_REACTIVATION_BRANCH_ACTION='DELETE_REACTIVATION_BRANCH_ACTION';
export const DELETE_REACTIVATION_DEVICE_ACTION='DELETE_REACTIVATION_DEVICE_ACTION';
//注销
export const ADD_DEREGISTRATION_BRANCH_ACTION = 'ADD_DEREGISTRATION_BRANCH';
export const ADD_DEREGISTRATION_DEVICE_ACTION = 'ADD_DEREGISTRATION_DEVICE';
export const MODIFY_DEREGISTRATION_BRANCH_ACTION='MODIFY_DEREGISTRATION_BRANCH_ACTION';
export const MODIFY_DEREGISTRATION_DEVICE_ACTION='MODIFY_DEREGISTRATION_DEVICE_ACTION';
export const DELETE_DEREGISTRATION_BRANCH_ACTION='DELETE_DEREGISTRATION_BRANCH_ACTION';
export const DELETE_DEREGISTRATION_DEVICE_ACTION='DELETE_DEREGISTRATION_DEVICE_ACTION';
//纳税人停用，注销新分支地址
export const TAXPAYER_ADDRESS_NEW_LEVEL1 = 'TAXPAYER_ADDRESS_NEW_LEVEL1';
export const TAXPAYER_ADDRESS_NEW_LEVEL2 = 'TAXPAYER_ADDRESS_NEW_LEVEL2';
export const TAXPAYER_ADDRESS_NEW_LEVEL3 = 'TAXPAYER_ADDRESS_NEW_LEVEL3';
export const TAXPAYER_ADDRESS_NEW_LEVEL4 = 'TAXPAYER_ADDRESS_NEW_LEVEL4';
export const TAXPAYER_ADDRESS_NEW_LEVEL5 = 'TAXPAYER_ADDRESS_NEW_LEVEL5';
//清除纳税人地址
export const CLEAR_TAXPAYER_ADDRESS_NEW_ACTION = 'CLEAR_TAXPAYER_ADDRESS_NEW_ACTION';
//查询域是否展示
export const SEARCH_FORM_DISPLAY = 'SEARCH_FORM_DISPLAY';
//法令全局搜索关键字
export const SEARCH_LIST_RELOAD = 'SEARCH_LIST_RELOAD';
//菜单全局搜索关键字
export const MENU_SEARCH_LIST_RELOAD = 'MENU_SEARCH_LIST_RELOAD';
